import "./App.css";
import MainPage from "./Components/MainPage";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Projects from "./Components/Projects";
import Projects001 from "./Components/Projects001";
import Projects004 from "./Components/Projects004";
import Projects005 from "./Components/Projects005";
function App() {

  return (
    <div className="App">
      <Router>

        <Routes>
          <Route path='/' exact element={<MainPage />} />
          <Route path='/projects' element={<Projects />} />
          <Route path='/projects/001' element={<Projects001 />} />
          <Route path='/projects/004' element={<Projects004 />} />
          <Route path='/projects/005' element={<Projects005 />} />

        </Routes>
      </Router>


    </div>
  );
}

export default App;
